// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let ProgramV2Api = class ProgramV2Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get an existing Program by Program identifier.
     * @param x_program_id The program id from the list of allowed program ids
     */
    async programGetByProgramId(x_program_id) {
        const _url_ = '/program/v2/Program0726a8fb';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ProgramModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get Programs by Tenant Id or Program Code
     * @param programCode
     * @param hasPromotion
     * @param promotionId
     */
    async programGetByTenantId(programCode, hasPromotion, promotionId) {
        const _url_ = '/program/v2/Programa634d9cb';
        let _params_ = {};
        let _headers_ = {};
        if (programCode !== undefined) {
            _params_['programCode'] = Serializer.serialize(programCode, "string");
        }
        if (hasPromotion !== undefined) {
            _params_['hasPromotion'] = Serializer.serialize(hasPromotion, "boolean");
        }
        if (promotionId !== undefined) {
            _params_['promotionId'] = Serializer.serialize(promotionId, "number");
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ProgramModels");
        }
        return response;
    }
};
ProgramV2Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], ProgramV2Api);
export { ProgramV2Api };
//# sourceMappingURL=programV2Api.js.map